import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { makeStyles } from "@material-ui/styles";
import { Card, CardContent, Grid, Box } from "@material-ui/core";
import clsx from "clsx";
import PropTypes from "prop-types";
import Paper from "@material-ui/core/Paper";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import Typography from "@material-ui/core/Typography";
import { useDispatch, useSelector } from "react-redux";
import { changeYear, fetchIncomes, fetchMonthIncomes } from "slices/incomes";
import SelectIncomesYearDropdown from "./SelectIncomesYearDropdown";
import { openModal } from "slices/modals";
import { months } from "utils/constants";
import {
  VideoLibrary,
  School,
  Forum,
  Assignment,
  YouTube,
  Book,
} from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    "& > * + *": {
      marginTop: theme.spacing(2),
      flexGrow: 1,
      backgroundColor: theme.palette.background.paper,
      maxWidth: 360,
    },
  },
  datePicker: {
    dispaly: "flex",
    alignItems: "end",
    justifyContent: "end",
    marginBottom: "20px",
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    padding: "20px",
    minHeight: "120px",
    borderRadius: "12px",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
    border: "1px solid #e2e8f0",
    transition: "all 0.2s ease",
    backgroundColor: "#ffffff",
    "&:hover": {
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
      borderColor: "#cbd5e1",
    },
  },
  monthValues: {
    alignItems: "stretch",
    marginBottom: "24px",
  },
  title: {
    fontSize: "12px",
    fontWeight: "500",
    color: "#64748b",
    marginBottom: "8px",
  },
  valueContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginTop: "8px",
  },
  value: {
    fontSize: "24px",
    fontWeight: "600",
    color: "#1e293b",
    lineHeight: "1.3",
  },
  iconWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "40px",
    height: "40px",
    borderRadius: "10px",
    backgroundColor: "#f1f5f9",
    "& svg": {
      fontSize: "20px",
      color: "#0093e2",
    },
  },
  month_statestique: {
    fontWeight: "600",
    fontSize: "18px",
    marginBottom: "20px",
    color: "#1e293b",
  },
}));
const currentYear = new Date().getFullYear();
const yearsIncomesList = [0, 1, 2, 3].map((i) => ({
  value: currentYear - i,
  text: String(currentYear - i),
}));

// Helper function to get icon for each card type
const getIconForCard = (id) => {
  const iconMap = {
    liveSessions: <VideoLibrary />,
    videoSilver: <VideoLibrary />,
    magazine: <Book />,
    qcm: <Assignment />,
    youtube: <YouTube />,
    correctedExam: <School />,
    forum: <Forum />,
  };
  return iconMap[id] || <School />;
};

const IncomesForm = (props) => {
  const { id } = useParams();
  const { className, edit, ...rest } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const { data, status, numbersCurrentMonth } = useSelector(
    (state) => state.incomes.yearIncomes
  );
  const { year } = useSelector((state) => state.incomes.currentDataDate);

  console.log({ numbersCurrentMonth, data });

  const headersRowIncomes = [
    { title: "Mois" },
    { title: "Solde" },
    { title: "Défaut" },
    { title: "Solde Final" },
    { title: "" },
  ];

  useEffect(() => {
    dispatch(fetchIncomes({ instructor: id, year: year }));
  }, [year, id, dispatch]);

  return (
    <div>
      <Typography className={classes.month_statestique}>
        Les chiffres de ce mois-ci :
      </Typography>
      <Grid id="top-row" container spacing={3} className={classes.monthValues}>
        {numbersCurrentMonth.length > 0 &&
          numbersCurrentMonth.map((item, index) => {
            return (
              <Grid item xs={12} sm={6} md={4} lg={2} key={index}>
                <Paper className={classes.paper} elevation={0}>
                  <Typography className={classes.title}>
                    {item.title}
                  </Typography>
                  <Box className={classes.valueContainer}>
                    <Typography className={classes.value}>
                      {item.value}
                      {item.unit && (
                        <span
                          style={{
                            fontSize: "13px",
                            fontWeight: "400",
                            color: "#64748b",
                            marginLeft: "2px",
                          }}
                        >
                          {item.unit}
                        </span>
                      )}
                    </Typography>
                    <Box className={classes.iconWrapper}>
                      {getIconForCard(item.id)}
                    </Box>
                  </Box>
                </Paper>
              </Grid>
            );
          })}
      </Grid>

      <Grid
        container
        alignItems="right"
        spacing={3}
        className={classes.datePicker}
      >
        <SelectIncomesYearDropdown
          optionsList={yearsIncomesList}
          changeHandler={(option) => dispatch(changeYear(option))}
        />
      </Grid>

      <Grid container spacing={3}>
        <Card {...rest} className={clsx(classes.root, className)}>
          {data?.length ? (
            <TableContainer component={Paper}>
              <Table className={classes.table} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    {headersRowIncomes.map((tableCell) => {
                      return <TableCell>{tableCell.title}</TableCell>;
                    })}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data.map((item, index) => (
                    <TableRow
                      key={item?.id}
                      // onClick={() => handleRowClick(item)}
                    >
                      <TableCell component="th" scope="row">
                        {item.month}
                      </TableCell>
                      <TableCell style={{ fontWeight: "bold" }}>
                        {item?.balance}
                      </TableCell>
                      <TableCell style={{ color: "red", fontWeight: "bold" }}>
                        {item?.fault}
                      </TableCell>
                      <TableCell
                        style={{ color: "#00B828", fontWeight: "bold" }}
                      >
                        {item?.finalBlance}
                      </TableCell>
                      <TableCell
                        align="right"
                        style={{
                          color: "#0093e2",
                          fontWeight: "bold",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          dispatch(
                            fetchMonthIncomes({
                              instructor: id,
                              month: months[index].monthNumber,
                              year,
                            })
                          );
                          dispatch(
                            openModal("month-incomes-modal", { id: id })
                          );
                        }}
                      >
                        <span>Voir détails</span>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <CardContent>
              <Typography variant="body2" color="textSecondary" component="p">
                This Teacher does not have any items
              </Typography>
            </CardContent>
          )}
        </Card>
      </Grid>
    </div>
  );
};
IncomesForm.propTypes = {
  className: PropTypes.string,
};

export default IncomesForm;
